import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import { actionCreators } from "./redux/sagas/userMenu/userMenu";
import Badge from "./smartComponents/badge";
import Messages from "./smartComponents/messages";
import WebcamCapture from "../../../components/webcamCapture/webcamCapture";
import ImageUpload from "../../../components/imageUpload/imageUpload";
import WebNotification from "react-web-notification";
import Modal from "react-modal";
import fallbackImg from "../../../../../public/avatars/original/missing.png";
import { Notification } from "./smartComponents/Notification";

export class UserMenuModule extends React.Component {
  constructor(props) {
    super(props);
    this.checkForUpload = this.checkForUpload.bind(this);
    this.checkForMessages = this.checkForMessages.bind(this);
    this.toggleLightTheme = this.toggleLightTheme.bind(this);
    this.handlePermissionGranted = this.handlePermissionGranted.bind(this);
    this.handlePermissionDenied = this.handlePermissionDenied.bind(this);
    this.handleNotSupported = this.handleNotSupported.bind(this);
    this.handleNotificationOnShow = this.handleNotificationOnShow.bind(this);
    this.handleModalNext = this.handleModalNext.bind(this);

    this.state = {
      showMenu: false,
      showMessages: false,
      showGoals: false,
      showImageEdit: false,
      showCamera: false,
      showUpload: false,
      haveGoals: false,
      ignore: true,
      goalEditOverlay: false,
      title: "",
      unreadMessages: 0,
      enableNextButton: false,
      acceptedTOS: false
    };
  }

  componentDidMount() {
    document.getElementById("globalOverlay").addEventListener("click", () => {
      this.setState({
        showMenu: false,
        showMessages: false
      });
      document.getElementById("globalOverlay").classList.remove("active");
      $(".user-box-wrapper").removeClass("active");
      // document.getElementById('user-box-wrapper').classList.remove('active')
    });
    this.props.fetchCurrentUser(this.props.currentUser.params);
    this.checkForMessages();
    if (this.props.currentUser.params.acceptedTosAt === null) {
      this.setState({
        modalOpen: true
      });
    }
  }

  toggleLightTheme(event) {
    if (event.target.checked) {
      document.body.classList.remove("dark");
      document.body.classList.add("light");
      this.props.updateThemePreferences("light");
      localStorage.setItem("lightTheme", true);
    } else {
      document.body.classList.remove("light");
      document.body.classList.add("dark");
      this.props.updateThemePreferences("dark");
      localStorage.setItem("lightTheme", false);
    }
  }

  checkForMessages() {
    // console.log('messages', this.state.unreadMessages, this.props.unreadMessages)
    if (
      (this.state.unreadMessages < this.props.unreadMessages) &
      (this.state.unreadMessages !== 0)
    ) {
      // console.log('not matching messages', this.state.unreadMessages, this.props.unreadMessages)
      this.handleButtonClick();
      this.setState({
        unreadMessages: this.props.unreadMessages
      });
    } else if (
      this.state.unreadMessages === 0 ||
      this.state.unreadMessages > this.props.unreadMessages
    ) {
      this.setState({
        unreadMessages: this.props.unreadMessages
      });
    } else {
      // console.log('matching')
    }
    this.props.pingMessages(this.props.userParams);
    setTimeout(this.checkForMessages, 15000);
  }

  toggleMenu() {
    if (this.state.showMenu) {
      // document.getElementById('user-box-wrapper').classList.remove('active')
      $(".user-box-wrapper").removeClass("active");
      document.getElementById("globalOverlay").classList.remove("active");
      this.setState({
        showMenu: false
      });
    } else {
      // document.getElementById('user-box-wrapper').classList.add('active')
      $(".user-box-wrapper").addClass("active");
      document.getElementById("globalOverlay").classList.add("active");
      this.setState({
        showMenu: true
      });
    }
  }

  toggleMessages() {
    if (this.state.showMessages) {
      this.setState({
        showMessages: false
      });
    } else {
      this.setState({
        showMessages: true
      });
    }
  }

  modifyMessage(id, deleMe, markAsRead) {
    let data = {
      id: id,
      deleMe: deleMe,
      markAsRead: markAsRead
    };
    this.props.modifyMessage(data);
    // console.log(data)
  }

  saveImage(data, id, orgId) {
    this.props.uploadPhoto({
      img: data,
      id: id,
      orgId: orgId
    });
    this.props.imageUploading(true);
    this.checkForUpload();
  }

  checkForUpload() {
    if (!this.props.imageBeingUploaded) {
      setTimeout(this.checkForUpload, 100);
    } else {
      this.setState({
        showCamera: false,
        showUpload: false,
        showImageEdit: false
      });
    }
  }

  editOverlay(value) {
    this.setState({
      goalEditOverlay: value
    });
    // console.log('edit overlay active', value)
  }

  handlePermissionGranted() {
    // console.log('Permission Granted');
    this.setState({
      ignore: false
    });
  }

  handlePermissionDenied() {
    // console.log('Permission Denied');
    this.setState({
      ignore: true
    });
  }

  handleNotSupported() {
    // console.log('Web Notification not Supported');
    this.setState({
      ignore: true
    });
  }

  handleNotificationOnClick() {
    // console.log(e, 'Notification clicked tag:' + tag);
    parent.focus();
    window.focus(); // just in case, older browsers
  }

  handleNotificationOnError() {
    // console.log(e, 'Notification error tag:' + tag);
  }

  handleNotificationOnClose() {
    // console.log(e, 'Notification closed tag:' + tag);
  }

  handleNotificationOnShow() {
    this.playSound();
    // console.log(e, 'Notification shown tag:' + tag);
  }

  playSound() {
    document.getElementById("sound").play();
  }

  handleButtonClick() {
    if (this.state.ignore) {
      return;
    }

    const now = Date.now();

    const title = "Notification from iKizmet";
    const body = "You have new unread messages.";
    const tag = now;
    const icon =
      "https://s3.amazonaws.com/ikizmet-production-images/broswer-notifications/KIZ_Logo_square.png";

    // Available options
    // See https://developer.mozilla.org/en-US/docs/Web/API/Notification/Notification
    const options = {
      tag: tag,
      body: body,
      icon: icon,
      lang: "en",
      dir: "ltr",
      sound: "https://s3.amazonaws.com/ikizmet-production-images/broswer-notifications/chin-up.mp3" // no browsers supported https://developer.mozilla.org/en/docs/Web/API/notification/sound#Browser_compatibility
    };
    this.setState({
      title: title,
      options: options
    });
  }

  handleModalNext() {
    if (this.state.acceptedTOS) {
      this.props.userAcceptTOS(this.props.currentUserId);
      this.setState({
        modalOpen: false
      });
    } else {
      this.setState({
        acceptedTOS: true
      });
      jQuery(function ($) {
        $(".tos-modal-wrapper").load("/privacy #privacy");
        $(".tosModal").scrollTop(0);
      });
    }
  }

  getParent() {
    return document.querySelector("body");
  }

  createMarkup(data) {
    return { __html: data };
  }

  getTOS() {
    $(".tos-modal-wrapper").load("/tos #ikizmet_tos");
  }

  onImageError(e) {
    e.target.src = fallbackImg;
  }

  render() {
    return (
      <div>
        <Modal
          ariaHideApp={false}
          parentSelector={this.getParent}
          className="tosModal custom-scroll-bar"
          closeTimeoutMS={500}
          isOpen={this.state.modalOpen}
          onRequestClose={this.closeModal}
          onAfterOpen={this.getTOS}
          style={{
            overlay: {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
              zIndex: 10000
            },
            content: {
              position: "absolute",
              top: "5%",
              left: "10px",
              width: "96vw",
              height: 500,
              bottom: 40,
              backgroundColor: "white",
              borderRadius: "10px",
              border: "solid 1px #444",
              padding: "25px",
              outline: "none",
              zIndex: 100000,
              overflow: "hidden",
              overflowY: "scroll"
            }
          }}
          contentLabel="TOS Modal"
        >
          <p style={{ textAlign: "center" }}>
            OUR TERMS OF SERVICE AND PRIVACY POLICY WERE RECENTLY UPDATED.
            <br />
            PLEASE AGREE TO UPDATED TERMS TO CONTINUE USING IKIZMET.
          </p>
          <div className="tos-modal-wrapper" />

          <button onClick={this.handleModalNext} active={this.enableNextButton}>
            AGREE
          </button>
        </Modal>

        <Notification />

        <div className="username" onClick={() => this.toggleMenu()}>
          {!this.state.showMenu & (this.props.unreadMessages !== 0) ? (
            <Badge />
          ) : (
            <p className="spacer" />
          )}
          <p className={`title ${this.state.showMenu && "active"}`}>
            {this.props.userParams.userFullName}
          </p>
          <img
            className={`user-avatar ${!this.state.showMenu && "active"}`}
            src={this.props.userImage}
            onError={this.onImageError}
          />
        </div>

        <div
          className={`user-info main-menu ${this.state.showMenu && "active"} ${
            !this.state.showMessages && "show"
          }`}
        >
          <div id="profileImageModule" onClick={() => this.setState({ showImageEdit: true })}>
            <div className="profileImageContainer">
              <img src={this.props.userImage} alt="Image" onError={this.onImageError} />
            </div>
          </div>
          <ul className={`user-info-inner active`}>
            <h2>User Settings</h2>
            <li>
              <a
                href={this.props.userParams.userLinks.editProfile}
                target="_blank"
                rel="noopener noreferrer"
              >
                Profile
              </a>
            </li>
            {this.props.userParams.adminLinks.reports !== undefined &&
            this.props.userParams.hasReportPermission &&
            !this.props.userParams.user.params.isAdmin ? (
              <li>
                <a href={this.props.userParams.adminLinks.reports}>Reports</a>
              </li>
            ) : null}
            {this.props.userParams.hasSettingsPermission &&
            !this.props.userParams.user.params.isAdmin ? (
              <li>
                <a href={this.props.userParams.adminLinks.settings}>Settings</a>
              </li>
            ) : null}
            {this.props.userParams.hasIntegrationsPermission &&
            !this.props.userParams.user.params.isAdmin ? (
              <li>
                <a href={this.props.userParams.adminLinks.integrations}>Integrations</a>
              </li>
            ) : null}
            <li>
              <a href={this.props.userParams.userLinks.changePassword}>Change Password</a>
            </li>
            <li>
              <a className="logout-link" href={this.props.userParams.userLinks.logout}>
                Log Out
              </a>
            </li>
            <li>
              <a href={"/privacy"} target="_blank" rel="noopener noreferrer">
                Privacy Policy
              </a>
            </li>
            <li>
              <a href={"/tos"} target="_blank" rel="noopener noreferrer">
                Terms of Service
              </a>
            </li>
            <li>
              Light Theme{" "}
              <input
                type="checkbox"
                className="ios8-switch"
                onChange={this.toggleLightTheme}
                checked={this.props.lightTheme}
                id="theme"
              />
              <label
                htmlFor="theme"
                style={{
                  top: "4px",
                  left: "7px",
                  position: "relative"
                }}
              />
            </li>
            {this.props.userParams.changeOrg !== "" && (
              <li>
                <b>
                  <a href={this.props.userParams.changeOrg}>Change Organization</a>
                </b>
              </li>
            )}
            {this.props.userParams.corporateReportingUrl && (
              <li>
                <b>
                  <a href={this.props.userParams.corporateReportingUrl}>Corporate Reporting</a>
                </b>
              </li>
            )}
            {this.props.userParams.user.params.isAdmin && (
              <span>
                <h2>Admin</h2>
                <li>
                  <a href={this.props.userParams.adminLinks.adminOrganizations}>Organizations</a>
                </li>
                <li>
                  <a href={this.props.userParams.adminLinks.adminClubreadyStores}>[CR] Stores</a>
                </li>
                <li>
                  <a href={this.props.userParams.adminLinks.adminMarianatekSites}>[MT] Sites</a>
                </li>
                <li>
                  <a href={this.props.userParams.adminLinks.adminMindbodySites}>[MBO] Sites</a>
                </li>
                <li>
                  <a href={this.props.userParams.adminLinks.adminUsers}>Users</a>
                </li>
                <li>
                  <a href={this.props.userParams.adminLinks.backendTasks}>Backend Tasks</a>
                </li>
                <li>
                  <a href="/admin/settings/clear_cache">Clear Cache</a>
                </li>
                <li>
                  <a href="/admin/settings/clear_black_list">Clear Black List IPs</a>
                </li>
                {this.props.userParams.adminLinks.reports !== undefined && (
                  <li>
                    <a href={this.props.userParams.adminLinks.reports}>Reports</a>
                  </li>
                )}
                {this.props.userParams.adminLinks.settings !== undefined && (
                  <li>
                    <a href={this.props.userParams.adminLinks.settings}>Settings</a>
                  </li>
                )}
                {this.props.userParams.adminLinks.integrations !== undefined && (
                  <li>
                    <a href={this.props.userParams.adminLinks.integrations}>Integrations</a>
                  </li>
                )}
                {this.props.userParams.importText && (
                  <li>
                    <a>{this.props.userParams.importText}</a>
                  </li>
                )}
                {this.props.userParams.lastCommit && (
                  <li>
                    <a href={this.props.userParams.lastCommit.link}>
                      git: {this.props.userParams.lastCommit.text}
                    </a>
                  </li>
                )}
              </span>
            )}
          </ul>
        </div>

        <div
          className={`user-info profileImage ${this.state.showMenu && "active"} ${
            this.state.showImageEdit && "show"
          }`}
        >
          {!this.state.showCamera & !this.state.showUpload ? (
            <div>
              <h2>
                <a className="back" onClick={() => this.setState({ showImageEdit: false })}>
                  &larr;
                </a>{" "}
                Edit Profile Image
              </h2>
              <img
                className="profile-image-preview current"
                src={this.props.userImage}
                onError={this.onImageError}
              />
            </div>
          ) : null}
          {!this.state.showCamera & !this.state.showUpload ? (
            <button onClick={() => this.setState({ showCamera: true })}>Use Webcam</button>
          ) : null}
          {!this.state.showCamera & !this.state.showUpload ? (
            <button onClick={() => this.setState({ showUpload: true })}>Upload Image</button>
          ) : null}
          {this.state.showCamera && (
            <div>
              <h2>
                <a className="back" onClick={() => this.setState({ showCamera: false })}>
                  &larr;
                </a>{" "}
                Profile Image Preview
              </h2>
              {this.props.imageBeingUploaded && (
                <div className="loading-overlay">
                  <p>Uploading</p>
                  <LoadingAnimation />
                </div>
              )}
              <WebcamCapture
                uploadImage={(data) =>
                  this.saveImage(
                    data,
                    this.props.userParams.user.params.id,
                    this.props.userParams.user.params.organization_id
                  )
                }
                cta="Capture"
              />
            </div>
          )}
          {this.state.showUpload && (
            <div>
              <h2>
                <a className="back" onClick={() => this.setState({ showUpload: false })}>
                  &larr;
                </a>{" "}
                Profile Image Preview
              </h2>
              {this.props.imageBeingUploaded && (
                <div className="loading-overlay">
                  <p>Uploading</p>
                  <LoadingAnimation />
                </div>
              )}
              <ImageUpload
                uploadImage={(data) =>
                  this.saveImage(
                    data,
                    this.props.userParams.user.params.id,
                    this.props.userParams.user.params.organization_id
                  )
                }
                cta="Capture"
              />
            </div>
          )}
        </div>

        <div
          className={`user-info messages ${this.state.showMenu && "active"} ${
            this.state.showMessages && "show"
          }`}
        >
          <h2>
            <a className="back" onClick={() => this.toggleMessages()}>
              &larr;
            </a>{" "}
            Message Center
          </h2>
          {this.props.messagesLoading && (
            <div className="loading-overlay">
              <LoadingAnimation />
            </div>
          )}
          <Messages
            modifyMessage={(id, deleMe, markAsRead) => this.modifyMessage(id, deleMe, markAsRead)}
          />
        </div>

        <div>
          {this.props.sendDesktopNotifications ? (
            <WebNotification
              ignore={this.state.ignore && this.state.title !== ""}
              notSupported={this.handleNotSupported}
              onPermissionGranted={this.handlePermissionGranted}
              onPermissionDenied={this.handlePermissionDenied}
              onShow={this.handleNotificationOnShow}
              onClick={this.handleNotificationOnClick}
              onClose={this.handleNotificationOnClose}
              onError={this.handleNotificationOnError}
              timeout={5000}
              title={this.state.title}
              options={this.state.options}
            />
          ) : (
            ""
          )}
          <audio id="sound" preload="auto">
            <source
              src="https://s3.amazonaws.com/ikizmet-production-images/broswer-notifications/chin-up.mp3"
              type="audio/mpeg"
            />
            <source
              src="https://s3.amazonaws.com/ikizmet-production-images/broswer-notifications/chin-up.ogg"
              type="audio/ogg"
            />
            <embed
              hidden
              autostart="false"
              loop={false}
              src="https://s3.amazonaws.com/ikizmet-production-images/broswer-notifications/chin-up.mp3"
            />
          </audio>
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    isLoading: state.userMenu.isLoading,
    unreadMessages: state.userMenu.unreadMessages,
    messagesLoading: state.userMenu.messagesLoading,
    userImage: state.userMenu.currentUser.avatarURL,
    isAdmin: state.userMenu.currentUser.isAdmin,
    imageBeingUploaded: state.userMenu.imageUploading,
    lightTheme: state.userMenu.lightTheme,
    acceptedTosAt: state.userMenu.currentUser.acceptedTosAt,
    currentUserId: state.userMenu.currentUser.id,
    sendDesktopNotifications: state.userMenu.currentUser.sendDesktopNotifications
  }),
  {
    fetchCurrentUser: actionCreators.fetchCurrentUser,
    pingMessages: actionCreators.pingMessages,
    modifyMessage: actionCreators.modifyMessage,
    uploadPhoto: actionCreators.uploadImage,
    imageUploading: actionCreators.imageUploading,
    updateThemePreferences: actionCreators.updateThemePreferences,
    userAcceptTOS: actionCreators.userAcceptTOS
  }
)(UserMenuModule);

UserMenuModule.propTypes = {
  modifyMessage: PropTypes.func.isRequired,
  unreadMessages: PropTypes.number,
  userParams: PropTypes.object,
  fetchCurrentUser: PropTypes.func.isRequired,
  currentUser: PropTypes.object,
  updateThemePreferences: PropTypes.func.isRequired,
  pingMessages: PropTypes.func.isRequired,
  sendDesktopNotifications: PropTypes.bool,
  lightTheme: PropTypes.bool,
  uploadPhoto: PropTypes.func.isRequired,
  imageUploading: PropTypes.func.isRequired,
  imageBeingUploaded: PropTypes.bool,
  userImage: PropTypes.string,
  isAdmin: PropTypes.bool,
  messagesLoading: PropTypes.bool,
  acceptedTosAt: PropTypes.string || PropTypes.bool,
  currentUserId: PropTypes.number,
  userAcceptTOS: PropTypes.func
};
